<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  }
}
</script>

<style>
#app {
  font-family: DIN Medium,-apple-system,BlinkMacSystemFont,PingFang SC,Segoe UI,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol!important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #4f5c72;
  font-weight: 500;
  margin: 0;
  padding: 0;
  line-height: 1;
  background-color: #edf1f6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue